/**
 * 惩罚原因配置
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, InputNumber } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import PunishReasonModal from './modal/PunishReasonModal';
import model from '@/reducers/system/parameter/model';

class ApplyReason extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() { }

    // 新建申诉理由
    _createRule = () => {
        this.setState({
            currentOpenMode: 'CREAT',
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlist(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }


    // 表格操作
    _tableAction = (id, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.setState({
                    currentOpenMode: 'EDITOR',
                    openModeParam: value,
                });
                break;
            case 'switch':
                http('/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.update', {//状态
                    id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this._searchHandle('useCache');
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }



    // 打开弹窗（创建/编辑）
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'CREAT':
                return <PunishReasonModal title='惩罚原因' visible={true} closeMode={this._closeMode} />;
            case 'EDITOR':
                return <PunishReasonModal title='惩罚原因' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this._searchHandle('useCache');// 重新渲染更新列表
        }
    }

    render() {
        const { list } = this.props;
        return (
            <KeepAlive id='5' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建惩罚原因' onClick={this._createRule} />
                    </div>
                    <TableContent renderData={list} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

ApplyReason.propTypes = {
    history: PropTypes.object, // 路由history对象
    list: PropTypes.object,
    getlist: PropTypes.func,//表格数据(action)
};

const mapStateToProps = (state) => {
    return {
        list: state.parameter.list,
    };
};
export default connect(mapStateToProps, { ...model.actions })(ApplyReason);
